import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { RouterModule } from '@angular/router';
import { APP_ROUTES } from './app.routes';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CarouselModule } from 'primeng/carousel';
import { DividerModule } from 'primeng/divider';

import { MaterialListComponent } from './components/material-scanner/material-list/material-list.component'
import { MaterialScanComponent } from './components/material-scanner/material-scan/material-scan.component'
import { MaterialCompareComponent } from './components/material-scanner/material-compare/material-compare.component'
import { MaterialVersionListComponent } from './components/material-scanner/material-version-list/material-version-list.component'
import { VersionImgSliderComponent } from './components/shared/version-img-slider/version-img-slider.component'
import { VersionImgViewerComponent } from './components/shared/version-img-viewer/version-img-viewer.component'
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    MaterialListComponent,
    MaterialScanComponent,
    MaterialCompareComponent,
    MaterialVersionListComponent,
    VersionImgSliderComponent,
    VersionImgViewerComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(APP_ROUTES),
    ButtonModule,
    InputTextModule, 
    CardModule,
    MenuModule,
    SplitButtonModule,
    CarouselModule,
    DialogModule,
    BrowserAnimationsModule,
    DividerModule
  ],
  bootstrap: [AppComponent],
  providers: [
    provideHttpClient(),
    DialogService
  ],

})
export class AppModule {}